import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UwLoaderHost } from './shared/ui/loader-host/uw-loader-host';

@Component({
  selector: 'uw-root',
  standalone: true,
  imports: [RouterOutlet, UwLoaderHost],
  template: `
    <router-outlet />
    <uw-loader-host />
  `,
})
export class App {}
